export default "__VITE_ASSET__DHjSLG_c__"